module.exports = __webpack_public_path__ + "static/media/Ebay.8734bb51.svg";